/**
 * orga-app-api - benutzerverwaltung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BenutzerTelefoneSichtbarkeitRequest { 
    telefon_id: string;
    ist_sichtbar: boolean;
    benutzer_id: string;
}

